<template>
    <div class="col-lg-4 col-sm-6 item-block__wrap">
        <span class="item-block__wrap-left"></span>
        <span class="item-block__wrap-right"></span>
        <div class="item-block__item">
            <div class="item-block__item-img-wrap">
                <a :href="product.url">
                    <img class="item-block__item-img" :src="product.img" alt="Product img">
                </a>
            </div>
            <a class="item-block__item-title js-item-block__item-title" :href="product.url" v-html="product.title"></a>
            <span class="item-block__item-brand" v-html="product.collectionListing"></span>
            <div class="item-block__item-colors js-item-block__item-colors">
				<div>
					<template v-for="(color, index) in product.color">
						<span class="color tooltip" :data-tooltip="color.colorName" :style="{backgroundImage: 'url(' + color.color + ')'}" :key="index"></span>
					</template>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['product'],

        mounted() {
            this.equalHeights('js-item-block__item-title');
            // this.equalHeights('js-item-block__item-colors');
        },

        methods: {
            equalHeights: (elName) => {
				setTimeout(() => {
					const products = document.getElementsByClassName(elName);
					let x = 0;

					Array.from(products).forEach((el) => {
						el.style.height = 'auto';
						if (el.offsetHeight > x) {
							x = el.offsetHeight;
						}
					});

					Array.from(products).forEach((el) => {
						el.style.height = `${x}px`;
					});

				}, 2000);
			}
        }
    };
</script>

<style lang="scss" scoped>
    .item-block__wrap {
        border: 1px solid transparent;
        padding: 0 20px;
        margin-bottom: 39px;

        @include mq($xl) {
            padding: 0 15px;
        }

        @include mq($lg) {
            margin-bottom: 25px;
        }

        &:hover {
            border: 1px solid $grey-lighter;

            .item-block__item {
                border: none;
            }
        }
    }

    .item-block__item-title {
        padding: 0;
    }

    .item-block__item-img-wrap {
        // min-height: 217px;
        max-width: 240px;
        height: 201px;
        min-height: 100px;
        margin: 0 auto 33px;

        @include mq($lg) {
            // min-height: 200px;
            margin-bottom: 20px;
        }
    }

    .item-block__item-img {
        max-width: 177px;
        width: 100%;
    }

    .item-block__item {
        border: none;
        padding: 50px 15px 15px;

        @include mq($lg) {
            padding: 15px;
        }
    }

    .item-block__item-brand {
        margin-bottom: 30px;

        @include mq($lg) {
            margin-bottom: 20px;
        }
    }
</style>
